import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TableContextMenuItem } from '../default-table/table-context-menu-item';
import { TableContextMenuContainerDirective } from '../default-table/table-context-menu-container.directive';

@Component({
  selector: 'yt-fw-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {
  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) { }

  isContextMenuVisible: boolean = true; 

  @Input() actionService: any; 
  @Input() ContextMenuItems: TableContextMenuItem[];

  @Output() ContextMenuItemClicked = new EventEmitter<TableContextMenuItem>();
  @Output() TableContextMenuItemClicked = new EventEmitter();
  
  @ViewChild(TableContextMenuContainerDirective, { static: false }) tableContextMenuContainer: TableContextMenuContainerDirective;
  

  ngOnInit() {
  }
    
  ContextMenuItemClick(contextMenuItem: TableContextMenuItem): void {
    this.ContextMenuItemClicked.emit(contextMenuItem);
    this.isContextMenuVisible = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isContextMenuVisible = false;
    }
  }
}
